import { GQL_ID, ProductGroupInfo } from '@@types'
import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_PRODUCT_CARD_FIELDS, SHORTCUT_PRODUCT_FIELDS, SHORTCUT_PRODUCT_SHOP_INFO } from '@shared/api/shortcuts'



export type SingleProductGroupQuery = {
  singleProductGroup?: ProductGroupInfo
}

export type SingleProductGroupVariables = {
  id: GQL_ID
  shop_id: GQL_ID
  style?: string
}

export const GQL_QUERY_SINGLE_PRODUCT_GROUP = gql`
  query singleProductGroup(
    $id: ID!
    $shop_id: ID!
    $style: String
  ) {
    singleProductGroup(id: $id, shop_id: $shop_id) {
      id
      label
      products {
        ${SHORTCUT_PRODUCT_FIELDS}
        ${SHORTCUT_PRODUCT_SHOP_INFO}
        ${SHORTCUT_PRODUCT_CARD_FIELDS}
      }
    }
  }
`

export const useSingleProductGroup = (variables: SingleProductGroupVariables) => {
  const result = useQuery<SingleProductGroupQuery, SingleProductGroupVariables>(
    GQL_QUERY_SINGLE_PRODUCT_GROUP,
    {
      variables,
      skip: !variables.id || !variables.shop_id,
    }
  )

  const group = result.data?.singleProductGroup
  const products = group?.products ?? []

  return {
    group,
    products,
    ...result
  }
}
